import React,{useState} from 'react';

const FianancialStrain = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
    const handleClick = (e) => {
      const buttonValue = e.target.value;
      setClickedButton(buttonValue);
      onNext(buttonValue);
    };
  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Financial Strain on Daily Life</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">Did your financial situation while repaying this loan ever affect your emotional wellbeing, mental health, or ability to cope day-to-day?</p>
        <div className="qs-actions">
          <button 
            type="button" 
            value={446}
            className={`qs-btn qs-btn--optn ${clickedButton == '446' ? 'btn-active' : ''}`} 
            onClick={handleClick}>
              Yes</button>
          <button 
            type="button" 
            value={447}
            className={`qs-btn qs-btn--optn ${clickedButton == '447' ? 'btn-active' : ''}`} 
            onClick={handleClick}>
              No</button>
        </div>
      </div>
    </>
  );
};

export default FianancialStrain;
